import { MessageCircle } from "lucide-react";

const PHONE = "919810899124";
const MESSAGE = encodeURIComponent(
  "Hello Lex Polaris Team, I would like to discuss a legal matter."
);

export default function WhatsAppFAB() {
  const href = `https://wa.me/${PHONE}?text=${MESSAGE}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Lex Polaris on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white shadow-[0_8px_24px_rgba(18,28,64,0.25)] hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={24} strokeWidth={1.75} />
    </a>
  );
}
